/**
 * Environment, validated once at module load.
 *
 * Same discipline as the API: a missing value throws at boot rather than
 * surfacing later as a confusing runtime failure. In a browser that means a
 * blank page with a clear console error during development, which is far easier
 * to diagnose than "login silently does nothing".
 */

function required(name: string, value: string | undefined): string {
  if (!value || value.trim() === '') {
    throw new Error(
      `Missing ${name}. Copy .env.example to .env and fill it in — see app/docs/ENVIRONMENT.md.`,
    );
  }
  return value;
}

export const env = {
  /** Base URL of the API. No trailing slash. */
  apiBaseUrl: required('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL).replace(/\/+$/, ''),

  clerkPublishableKey: required(
    'VITE_CLERK_PUBLISHABLE_KEY',
    import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  ),

  /**
   * Optional. Set only if the Clerk JWT template is *named* — a named template
   * must be requested explicitly via `getToken({ template })`, and a mismatched
   * name is a silent source of empty claims. Unset means the default session
   * token, which is the usual setup.
   */
  clerkJwtTemplate: import.meta.env.VITE_CLERK_JWT_TEMPLATE || undefined,
} as const;
